import billingApiModule from '../billingApi.module';

class BillingOrderApiService {
    constructor(__env, apiUtil, authenticationConstants) {
        this.__env = __env;
        this.apiUtil = apiUtil;
        this.authenticationConstants = authenticationConstants;
    }

    submitOrder(subscriptionId, planId, paymentMethodId) {
        var body = {
            planId
        };

        if (subscriptionId) {
            body.subscriptionId = subscriptionId;
        }

        if (paymentMethodId) {
            body.paymentMethodId = paymentMethodId;
        }

        return this.apiUtil.postWithBearerAuth(
            this.authenticationConstants.billing.name,
            `${this.__env.billingApiUrl}/api/v1/orders`,
            body
        );
    }
}

export default billingApiModule.service(
    'billingOrderApiService',
    BillingOrderApiService
);



// WEBPACK FOOTER //
// ./modules/billingApi/order/billingOrderApi.service.js